import React, {Fragment, useState} from 'react';
import IconLabel from "../../custom/icon/IconLabel";
import {Popover, PopoverPosition, ContentRenderer, ArrowContainer} from 'react-tiny-popover'
import useComponentVisible from '../../hook/useComponentVisible'

const PopoverCustomClick = ({
                                positions,
                                children,
                                content,
                                trigger = 'click'
                            }: {
    positions?: PopoverPosition[],
    children: React.ReactChild,
    content: React.ReactChild,
    trigger?: 'click' | 'mouseOver'
}) => {
    const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const { ref: selectorsRef, isComponentVisible, setIsComponentVisible } = useComponentVisible(false)


    return (
        <Popover
            ref={selectorsRef}
            isOpen={isComponentVisible}
            positions={positions}
            content={({position, childRect, popoverRect}) => (
                <ArrowContainer
                    position={position}
                    childRect={childRect}
                    popoverRect={popoverRect}
                    arrowColor={'#fff'}
                    arrowSize={10}
                    arrowStyle={{opacity: 1}}
                    className='popover-arrow-container'
                    arrowClassName='popover-arrow'
                >
                    <>
                        <div
                            className={"sh popover-content"}
                            onClick={(e) =>{e.stopPropagation(); setIsComponentVisible(!isComponentVisible)}}
                        >
                            {content}
                        </div>
                    </>
                </ArrowContainer>
            )}
        >
            <div onClick={(e) =>{e.stopPropagation(); setIsComponentVisible(!isComponentVisible)}}>
              {children}
            </div>
        </Popover>
    );
};

export default PopoverCustomClick;
